export default __webpack_public_path__ + "static/media/portfolio-laptop-side.e65f364f.webp";